import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { get } from "../../utils/apiManager";

const pill = (active) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 10px', borderRadius: 100, fontSize: 12, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
    <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
  </span>
);

const InfoRow = ({ label, value }) => (
  <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #f0f2f8' }}>
    <div style={{ width: 130, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>{label}</div>
    <div style={{ fontSize: 14, color: '#0a1628' }}>{value}</div>
  </div>
);

const ViewOne = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [emailTemplate, setEmailTemplate] = useState({});

  useEffect(() => {
    if (location?.search) getOneEmailTemplate(location.search.split("?")[1]);
  }, []);

  const getOneEmailTemplate = (id) => {
    get(`/email-template/${id}`)
      .then((res) => setEmailTemplate(res?.datas || {}))
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 28px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>View Email Template</h3>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => Navigate(`/admin/email/edit?${location.search.split("?")[1]}`)}
              style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>✎ Edit</button>
            <button onClick={() => Navigate('/admin/email')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back</button>
          </div>
        </div>
        <div style={{ padding: '8px 28px 20px' }}>
          <InfoRow label="Title" value={emailTemplate?.title} />
          <InfoRow label="Slug" value={
            <span style={{ background: '#f0f2f8', color: '#5a6a8a', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', fontSize: 13 }}>{emailTemplate?.slug}</span>
          } />
          <InfoRow label="Subject" value={emailTemplate?.subject} />
          <InfoRow label="By Whom" value={emailTemplate?.type || '—'} />
          <InfoRow label="Status" value={pill(emailTemplate?.isActive)} />
          <div style={{ display: 'flex', gap: 16, padding: '10px 0', borderBottom: '1px solid #f0f2f8' }}>
            <div style={{ width: 130, flexShrink: 0, fontSize: 13, fontWeight: 600, color: '#9aa5c0' }}>Flags</div>
            <div style={{ display: 'flex', gap: 8 }}>
              {emailTemplate?.isCompany && <span style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>Company</span>}
              {emailTemplate?.isSelf && <span style={{ background: '#f0fdf4', color: '#15803d', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>Self</span>}
              {emailTemplate?.isModified && <span style={{ background: '#fffbeb', color: '#92400e', padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>Modified</span>}
            </div>
          </div>
          <div style={{ padding: '14px 0' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#9aa5c0', marginBottom: 12 }}>Email Body</div>
            <div style={{ background: '#f8f9fc', borderRadius: 10, border: '1px solid #edf0f7', padding: '20px', fontSize: 14, color: '#3a4a6a', lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: emailTemplate?.description }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOne;
